import ddApi from "../api/dd-api";

const register = (firstName, lastName, email, password) => {
  return ddApi.post("register", {
    firstName,
    lastName,
    email,
    password
  });
};

const login = (email, password) => {
  return ddApi
    .post("login", {
      email,
      password
    })
    .then(response => response.data);
};

const logout = () => {
  return ddApi.post("logout");
};

const getProfile = () => {
  return ddApi.get("user").then(response => response.data);
};

const findById = id => {
  return ddApi.get(`/user/${id}`).then(response => response.data);
};

export default {
  register,
  login,
  logout,
  getProfile,
  findById
};
